import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from "@mui/material/LinearProgress";
import { isMobile } from "../App/utils";
import { colorText } from "../App/theme";

const LocalLoader = ({ open, blocking = false, backgroundColor, backdropOpacity, timeout, text, color }) => {
    const [percentage, setPercentage] = useState(0);
    const [isOpen, setIsOpen] = useState(open);
    const isNumber = typeof open === 'number';

    useEffect(() => {
        if (isNumber && open >= 1 && open <= 100) {
            setPercentage(open);
        } else if (typeof open === 'boolean') {
            setPercentage(open ? 100 : 0);
        }

        setIsOpen(open);

        let timer;
        if (open && timeout) {
            timer = setTimeout(() => {
                setIsOpen(false);
            }, timeout);
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [open, timeout, isNumber]);

    const style = { zIndex: 10000, color: colorText };
    if (backdropOpacity) style.opacity = backdropOpacity;
    if (backgroundColor) style.backgroundColor = backgroundColor;

    return (
        isOpen && (
            !blocking
                ? <LinearProgress
                    variant={isNumber ? "determinate" : "indeterminate"}
                    value={percentage}
                    color={color || 'secondary'}
                    style={{
                        position: 'fixed',
                        height: isMobile ? 4 : 4,
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 10000,
                    }}
                />
                : <Backdrop open={!!isOpen} style={style}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {isNumber ? (
                            <CircularProgress variant="determinate" value={percentage} />
                        ) : (
                            <CircularProgress />
                        )}
                        {text && (
                            <div style={{
                                marginTop: 10,
                                fontSize: 20,
                                padding: '10px 20px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
                                borderRadius: 8,
                                color: '#fff', // Text color
                            }}>
                                {text}
                            </div>
                        )}
                    </div>
                </Backdrop>
        )
    );
};

export default LocalLoader;